import { render, staticRenderFns } from "./updateSetting.vue?vue&type=template&id=d815c78e&scoped=true&"
import script from "./updateSetting.vue?vue&type=script&lang=js&"
export * from "./updateSetting.vue?vue&type=script&lang=js&"
import style0 from "./updateSetting.vue?vue&type=style&index=0&id=d815c78e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d815c78e",
  null
  
)

export default component.exports